var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.computedCustomClass,style:(_vm.customStyle)},[_c('use',{attrs:{"xlink:href":'#strype-svgicon-'+_vm.name,"fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }